var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('report-performance-thresholds',{attrs:{"performanceThresholds":_vm.performanceThresholds}}),_c('report-block-row',{attrs:{"items":_vm.shiftsRow}}),(_vm.items.length > 1)?_c('report-block-row',{attrs:{"items":_vm.combinedRow}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }